import { updateObject } from "../../../../shared";
import {
  globalConstants,
  PAGINATION_DEFAULTS,
  aiReplyReduxConstants,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  GET_BRAND_SOCIAL_LINKS,
  RESET_BRAND_SOCIAL_LINKS,
  GET_ALL_BRANDS_FOR_AI_REPLY,
} = aiReplyReduxConstants;

// Start the brand list with the shared page defaults.
const initialState = {
  aiReplyData: [],
  aiReplyPagination: {
    ...PAGINATION_DEFAULTS,
  },
  brandSocialLinks: {},
};

export const aiReplyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_BRANDS_FOR_AI_REPLY + SUCCESS:
      return updateObject(state, {
        aiReplyData: action.data.data,
        aiReplyPagination: action.data.page,
      });
    case GET_ALL_BRANDS_FOR_AI_REPLY + FAILURE:
      return updateObject(state, {
        aiReplyData: initialState.aiReplyData,
      });
    case GET_BRAND_SOCIAL_LINKS + SUCCESS:
      return updateObject(state, {
        brandSocialLinks: action.data,
      });

    case RESET_BRAND_SOCIAL_LINKS + SUCCESS:
      return updateObject(state, {
        brandSocialLinks: {},
      });
    default:
      return state;
  }
};
